import errorCode from './errorCode'

export default {
  // 注册错误对象
  errorCode,
  // format date
  formatDate: time => {
    let date = new Date(String(time).length === 10 ? time * 1000 : time)
    var mm = date.getMonth() + 1
    var dd = date.getDate()

    return [date.getFullYear(),
      (mm > 9 ? '' : '0') + mm,
      (dd > 9 ? '' : '0') + dd
    ].join('-')
  },

  // format time
  formatTime: time => {
    let date = new Date(String(time).length === 10 ? time * 1000 : time)
    return [
      (date.getHours() > 9 ? '' : '0') + date.getHours(),
      (date.getMinutes() > 9 ? '' : '0') + date.getMinutes(),
      (date.getSeconds() > 9 ? '' : '0') + date.getSeconds()
    ].join(':')
  },

  // format price
  formatPrice: price => {
    if (!price) price = 0
    return Math.floor(price / 100)
  },

  parseError (err) {
    let code = ''
    if (err && err.error && err.error.code) {
      code = this.errorCode.account[String(err.error.code)]
    } else {
      code = '请求失败，请重试'
    }
    return code
  },

  getQueryString (link, key) {
    var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
    var queryString = link.split('?').length > 1 ? link.split('?')[1] : ''
    var r = queryString.match(reg)
    if (r !== null) return decodeURIComponent(r[2])
    return ''
  },

  getUa () {
    let res = 'pc'
    let userAgentInfo = navigator.userAgent.toLowerCase()
    let Agents = ['iphone', 'ipod', 'android', 'mobile', 'blackberry', 'webos', 'incognito', 'webmate', 'bada', 'nokia', 'lg', 'ucweb', 'skyfire']
    for (let i = 0; i < Agents.length; i++) {
      if (userAgentInfo.indexOf(Agents[i]) > 0) {
        // 说明是手机了，接下来分别看是不是微信qq等，这里有注意先微信后qq，因为微信的也包含qq字段
        if (userAgentInfo.match(/Weibo/i)) {
          res = 'weibo'
        } else if (userAgentInfo.match(/micromessenger/i)) {
          res = 'weixin'
        } else if (userAgentInfo.match(/QQ/i)) {
          res = 'qq'
        } else {
          res = 'mobile'
        }
        break
      }
    }
    return res
  },

  isInWechat () {
    return this.getUa() === 'weixin'
  },

  isIOS () {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },

  shareInWeixin (params) {
    if (this.isInWechat()) {
      const defaultTitle = '账户中心 - 极客邦科技'
      const defaultCover = 'https://static001.geekbang.org/static/www/img/favicon-96x96.8e64510.png'
      window.wx.ready(() => {
        window.wx.onMenuShareTimeline({
          title: params.title || defaultTitle,
          link: params.url || window.location.href,
          imgUrl: defaultCover
        })
        window.wx.onMenuShareAppMessage({
          title: params.title || defaultTitle,
          link: params.url || window.location.href,
          imgUrl: defaultCover,
          desc: params.desc || 'https://account.geekbang.org'
        })
      })
    }
  },

  thirdLogin (type, redirect, params) {
    // type: wechat, weibo, qq; redirect: 登录成功后返回原址
    if (type === 'wechat' && this.isInWechat()) {
      type = 'wechatopen'
    }
    let cbUrl = `/thirdlogin` // 扫码成功后台回来的地址
    // console.log(redirect)
    // console.log(params)
    // console.log(this.thirdLoginUrl(cbUrl, type, 0, redirect, params))
    window.location.href = this.thirdLoginUrl(cbUrl, type, 0, redirect, params)
  },

  thirdLoginUrl (url, type, bind, cb, params = {}) {
    // 三方登录跳转地址合成
    // 参数说明
    // 1 url: 微信扫码后回前端的地址  格式 /thirdlogin
    // 2 type: 三方登录类型， weixin, qq, weibo
    // 3 bind: 是绑定账号或者是登录账号 登录为 0 绑定为 1
    // 4 [cb]: 三方登录后返回地址，这个地址是从登录界面传来的。比如从直播过来，正常登录后会返回到直播，如果用户点击三方登录的话同样需要返回来处，这时需要穿这个参数
    let baseUrl = 'https://account.geekbang.org'
    let redirect
    type = encodeURIComponent(type)
    bind = encodeURIComponent(bind)
    redirect = `${baseUrl}${url}?type=${type}&is_bind=${bind}`
    let keys = Object.keys(params)
    if (keys.length > 0) {
      keys.forEach(ele => {
        redirect += `&${ele}=${params[ele]}`
      })
    }
    if (cb) {
      redirect += `&redirect=${encodeURIComponent(cb)}`
    }
    redirect = encodeURIComponent(redirect)
    // console.log(redirect)
    let result = `${baseUrl}/account/oauth/authorize?type=${type}&is_bind=${bind}&redirect_url=${redirect}`
    return result
  },

  checkUrl (str) {
    // 检测是否是正确的 redirect url 并返回
    let reg = /^http[s]?:\/\/\w+\.geekbang\.org($|\/[^\s]*)/i
    // let text = decodeURIComponent(str)
    return reg.test(str) ? str : ''
  }
}
